import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DoggyhubService } from '../doggyhub.service';
import { GetArticleResponseDTO } from '../doggyhub.dto';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.page.html',
  styleUrls: ['./articles.page.scss'],
})
export class ArticlesPage implements OnInit, OnDestroy {
  articlesSub: Subscription;
  articles: GetArticleResponseDTO[];
  isLoading = true;
  HasMoreData = true;
  constructor(private doggyhubService: DoggyhubService) {}

  ngOnInit() {
    this.articlesSub = this.doggyhubService
      .getArticles(0)
      .subscribe((articles) => {
        this.articles = articles;
        if (this.articles.length === 0) this.HasMoreData = false;
        else this.HasMoreData = true;
        this.isLoading = false;
      });
  }

  handleRefresh(event: any) {
    this.HasMoreData = true;
    this.articlesSub = this.doggyhubService
      .getArticles(0)
      .subscribe((articles) => {
        this.articles = articles;
        if (this.articles.length === 0) this.HasMoreData = false;
        else this.HasMoreData = true;
        this.isLoading = false;
        event.target.complete();
      });
  }

  onIonInfinite(event: any) {
    this.articlesSub = this.doggyhubService
      .getArticles(this.articles[this.articles.length - 1].id)
      .subscribe((articles) => {
        this.articles = this.articles.concat(articles);
        const hasLastPost = this.articles.find((a) => a.isLastPost === true);
        if (hasLastPost === undefined) event.target.complete();
        else this.HasMoreData = false;
      });
  }

  ngOnDestroy() {
    if (this.articlesSub) this.articlesSub.unsubscribe();
  }
}
